var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20084 19.7803C7.93305 19.4874 7.93305 19.0126 8.20084 18.7197L14.3445 12L8.20084 5.2803C7.93305 4.9874 7.93305 4.5126 8.20084 4.2197C8.46862 3.9268 8.9028 3.9268 9.17059 4.2197L15.7992 11.4697C16.0669 11.7626 16.0669 12.2374 15.7992 12.5303L9.17059 19.7803C8.9028 20.0732 8.46863 20.0732 8.20084 19.7803Z",
    fill: "#A6A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.e158f07861a972deb995711c92761e92.svg";
export { ForwardRef as ReactComponent };